






















/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as util from "@/util";
import "@simonwep/pickr/dist/themes/classic.min.css"; // 'nano' theme

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Pickr = require("@simonwep/pickr/dist/pickr.es5.min.js");

// https://github.com/Simonwep/pickr
// One of the following themes
// import '@simonwep/pickr/dist/themes/classic.min.css';   // 'classic' theme
// import '@simonwep/pickr/dist/themes/monolith.min.css';  // 'monolith' theme
// Modern or es5 bundle
// import Pickr from '@simonwep/pickr/dist/pickr.es5.min';

@Component
export default class ColorPicker extends Vue {
  @Prop({ default: "#232323" }) value!: string;

  pickerName = "picker";
  pickr: any = null;

  defaultProps = {
    theme: "classic",
    swatches: [
      "rgb(0, 0, 0)",
      "rgb(244, 67, 54)",
      "rgb(233, 30, 99)",
      "rgb(156, 39, 176)",
      "rgb(103, 58, 183)",
      "rgb(63, 81, 181)",
      "rgb(33, 150, 243)",
      "rgb(3, 169, 244)",
      "rgb(0, 188, 212)",
      "rgb(0, 150, 136)",
      "rgb(76, 175, 80)",
      "rgb(139, 195, 74)",
      "rgb(205, 220, 57)",
      "rgb(255, 235, 59)",
      "rgb(255, 193, 7)"
    ],
    position: "top-end",
    defaultRepresentation: "HEX",
    lockOpacity: true,
    components: {
      preview: true,
      opcacity: false,
      hue: true,
      interaction: {
        hex: false,
        rgba: false,
        hsva: false,
        input: true,
        clear: false,
        save: true,
        cancel: true
      }
    },
    strings: {
      save: "Guardar",
      clear: "Limpiar",
      cancel: "Cancelar"
    },
    onSave: this.onSave
  };

  created() {
    this.pickerName = "cpic" + +new Date();
    this.onValue(this.value);
  }

  mounted() {
    const pickr = new Pickr({
      el: "#" + this.pickerName,
      ...this.defaultProps
    });
    this.pickr = pickr;
    this.pickr
      .on("save", (color: any) => {
        this.onSave(color);
      })
      .on("init", () => {
        this.onValue(this.value);
      })
      .on("hide", () => {
        this.onValue(this.value);
      })
      .on("show", () => {
        this.onValue(this.value);
      })
      .on("cancel", (instance: any) => {
        this.onValue(this.value);
        instance.hide();
      });
  }

  cmdChange() {
    this.pickr.show();
  }

  @Watch("value")
  onValue(newValue: string) {
    if (this.pickr) {
      this.pickr.setColor(newValue, true);
      this.pickr.applyColor(true);
    }
  }

  onSave(val: any) {
    this.$emit("input", val.toHEXA().toString());
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get rulesPrimaryColor() {
    return [util.rules.hexColor(this.lang.ruleHtmlFormat)];
  }
}
